const getters = {
    giftCollections(state){
        return state.giftCollections;
    },
    addonProducts(state){
        return state.addonProducts;
    },
    selectedCollection(state){
        return state.selectedCollection
    },
    addressQty(state){
        return state.addressQty;
    },
    emailFile(state){
        return state.emailFile;
    },
    emailFileData(state){
        return state.emailFileData;
    },
    multipleNotificationDate(state){
        return state.multipleNotificationDate;
    },
    selectedFilters(state){
        return state.selectedFilters;
    }
};

export default getters;
